import { render, staticRenderFns } from "./Head-Tips.vue?vue&type=template&id=6acd91ae&scoped=true&"
import script from "./Head-Tips.vue?vue&type=script&lang=js&"
export * from "./Head-Tips.vue?vue&type=script&lang=js&"
import style0 from "./Head-Tips.vue?vue&type=style&index=0&id=6acd91ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acd91ae",
  null
  
)

export default component.exports